import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraHubGrid } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { BadgeCheck, Building2, CalendarDays, FileBadge, FolderKanban, LayoutDashboard, Network } from 'lucide-react';
import { PageBody, PageHero } from '../../components/layout';
import { renderRouterLink } from '../../lib/renderRouterLink';
const sections = [
    {
        href: '/delivery/command-center',
        testid: Testids.delivery.overviewCardCommandCenter,
        icon: LayoutDashboard,
        title: 'Command Center',
        description: 'COO cross-project rollups — funding utilization, on-time delivery, evidence completeness, and risk/issue counts across portfolios and sectors.'
    },
    {
        href: '/delivery/org',
        testid: Testids.delivery.overviewCardOrg,
        icon: Network,
        title: 'Organization',
        description: 'Sectors, business units, portfolios — the org hierarchy.'
    },
    {
        // Registries moved to a root-level home; this card follows them there.
        href: '/registries',
        testid: Testids.delivery.overviewCardRegistries,
        icon: Building2,
        title: 'Registries',
        description: 'Companies, contacts, government orgs, vehicles, and labor categories.'
    },
    {
        href: '/delivery/programs',
        testid: Testids.delivery.overviewCardPrograms,
        icon: FolderKanban,
        title: 'Programs',
        description: 'Active program records and everything tied to them — audits, deviations, and corrective actions live inside each program.'
    },
    {
        href: '/delivery/audit-templates',
        testid: Testids.delivery.overviewCardTemplates,
        icon: FileBadge,
        title: 'Audit Templates',
        description: 'Reusable audit definitions and their question sets.'
    },
    {
        href: '/delivery/evidence-board',
        testid: Testids.delivery.overviewCardEvidenceBoard,
        icon: BadgeCheck,
        title: 'Proof & Evidence Board',
        description: 'Deliverable evidence and proof-of-delivery status across the whole portfolio.'
    },
    {
        href: '/delivery/calendar',
        testid: Testids.delivery.overviewCardCalendar,
        icon: CalendarDays,
        title: 'Delivery Calendar',
        description: 'Cross-project deadlines — deliverable due dates, option-period expirations, and protest/debrief windows across all authorized programs.'
    }
];
export function DeliveryOverviewPage() {
    const items = sections.map((section)=>{
        const Icon = section.icon;
        return {
            id: section.href,
            title: section.title,
            description: section.description,
            icon: /*#__PURE__*/ _jsx(Icon, {
                className: "h-5 w-5"
            }),
            href: section.href
        };
    });
    return /*#__PURE__*/ _jsxs(PageBody, {
        children: [
            /*#__PURE__*/ _jsx(PageHero, {
                title: "Delivery",
                subtitle: "Programs, audits, and the rest of the delivery domain"
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-testid": Testids.delivery.overviewPage,
                children: /*#__PURE__*/ _jsx(SpecraHubGrid, {
                    items: items,
                    renderLink: renderRouterLink,
                    columns: 3,
                    // SpecraHubGrid owns the card testid via this hook (it overrides any
                    // data-testid on the item); map back to each section's stable testid
                    // so the delivery journeys keep navigating through them.
                    getItemTestId: (item)=>sections.find((s)=>s.href === item.id)?.testid
                })
            })
        ]
    });
}
